import React from "react";
import WaitlistForm from "@/components/landing/WaitlistForm";
import { useLanguage } from "@/lib/i18n";

export default function FinalCTA() {
  const { t } = useLanguage();

  return (
    <section
      id="final-cta"
      className="bg-[#F9F8F6] py-24 sm:py-32 lg:py-40 relative overflow-hidden"
      data-testid="final-cta-section"
    >
      <div className="pointer-events-none absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#B4C5A4]/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[#0B2545]/10 blur-3xl" />

      <div className="max-w-3xl mx-auto px-6 lg:px-10 relative">
        <div className="reveal text-center mb-12">
          <p className="text-xs uppercase tracking-[0.24em] text-[#0B2545] font-sans-display mb-5">
            {t("finalCta.eyebrow")}
          </p>
          <h2 className="font-sans-display text-3xl sm:text-4xl lg:text-[52px] tracking-tight text-[#0F172A] leading-[1.05] mb-6">
            {t("finalCta.title")}
            <span className="block font-serif-display italic font-light text-[#0B2545]">
              {t("finalCta.titleEmph")}
            </span>
          </h2>
          <p className="text-[#475569] text-base sm:text-lg leading-relaxed max-w-xl mx-auto">
            {t("finalCta.subtitle")}
          </p>
          <p className="text-[#475569] text-sm leading-relaxed max-w-lg mx-auto mt-4 italic">
            {t("finalCta.smallnote")}
          </p>
        </div>

        <div className="reveal bg-white border border-slate-200 rounded-2xl p-8 sm:p-12 shadow-[0_4px_30px_-12px_rgba(11,37,69,0.12)]">
          <WaitlistForm
            variant="hero"
            source="final-cta"
            buttonLabel={t("finalCta.button")}
          />
          <p className="text-xs text-[#475569] mt-5 text-center">
            {t("finalCta.microcopy")}
          </p>
        </div>

        <p className="text-center text-xs text-[#475569] mt-8 max-w-md mx-auto">
          {t("finalCta.disclaimer")}
        </p>
      </div>
    </section>
  );
}
